import { createGlobalStyle } from 'styled-components'
import { theme } from 'styled-tools'

const GlobalStyles = createGlobalStyle`   
  html {
      overflow: -moz-scrollbars-vertical; 
      overflow-y: scroll;
  }
`

export default {
  global: {
    fontSmoothing: 'antialiased',
    boxSizing: 'border-box',
    dl: {
      marginTop: '0px',
    },
  },
  colors: {
    link: '#333',
    accentShadow: '0 0 0 4px rgba(150, 150, 150, 0.16)',
    secondaryBackgroundColor: '#f9f9f9',
  },
  typography: {
    pageTitle: {
      fontWeight: 400,
    },
    usp: {
      mobile: {
        fontSize: '22px',
      },
    },
    headline: {
      fontWeight: 300,
      fontSize: '30px',
      fontSizeDesktop: '30px',
      fontSizeLarge: '30px',
      textTransform: 'uppercase !important',
      marginBottom: '5px',
      marginBottomDesktop: '5px',
    },
    subHeadline: {
      fontWeight: 700,
    },
    title: {
      fontWeight: 300,
    },
    paragraph: {
      fontWeight: 300,
      fontWeightLarge: 300,
      lineHeight: '24px',
    },
    storeName: {
      fontWeight: 400,
    },
  },
  header: {
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    color: theme('colors.link'),
    height: '50px',
    heightDesktop: '80px',
    heightDesktopWithBanner: '175px',
    logoMargin: '11px 0 0',
    fontFamily: theme('typography.paragraph.fontFamily'),
  },
  contentHeader: {
    heading: {
      mobile: {
        fontSize: '26px',
      },
    },
    otherNeeds: {
      fontSize: {
        mobile: '13px',
      },
      desktop: {
        positionTop: '-68px',
        marginBottom: '-68px',
      },
      mobile: {
        positionTop: '-57px',
        marginBottom: '-57px',
      },
    },
    usps: {
      mobile: {
        fontSize: '22px',
      },
    },
  },
  designer: {
    minHeight: '200px',
    padding: {
      desktop: '0 35px',
      mobile: '0 20px',
    },
    margin: {
      desktop: '30px 0',
      mobile: '15px 0 30px 0',
    },
    headline: {
      fontSize: '18px',
      fontWeight: 700,
      textTransform: {
        normal: 'uppercase',
      },
      margin: '25px 0 5px 0',
    },
    paragraph: {
      lineHeight: '24px',
      lineHeightDesktop: '24px',
    },
    name: {
      fontWeight: 700,
    },
    location: {
      fontWeight: 300,
    },
    left: {
      margin: '0 0 10px 0',
    },
    right: {
      flexDirection: 'row-reverse',
    },
  },
  grid: {
    containerMaxWidth: '1112px',
  },
  button: {
    colors: {
      primaryColor: '#fff',
      primaryBackground: '#333',
    },
    fontWeight: 700,
    textTransform: 'none',
    fontSize: '15px',
    letterSpacing: '.5px',
    border: '1px solid transparent',
    blockButtonWidth: 'auto',
    wideButtonWidth: 'auto',
  },
  tabs: {
    fontWeight: 300,
    activeFontWeight: 400,
    color: {
      default: '#000',
      active: '#333',
    },
    header: {
      link: {
        borderBottom: '1px solid currentColor',
        textDecoration: 'none',
        fontWeight: 400,
      },
    },
  },
  showMore: {
    fontWeight: 400,
  },
  forms: {
    position: {
      top: '22px',
    },
    paddingInput: '22px',
    colors: {
      prefilledBackground: '#f1f1f1',
      valid: '#9be587',
    },
    prepForm: {
      headline: {
        mobile: {
          fontSize: '26px',
          fontWeight: 700,
          marginTop: '30px',
          lineHeight: '36px',
          textTransform: {
            normal: 'none',
          },
        },
        desktop: {
          fontSize: '30px',
          fontWeight: 700,
          marginTop: '60px',
          lineHeight: '48px',
          textTransform: {
            normal: 'none',
          },
        },
      },
      paragraph: {
        lineHeight: '20px',
        margin: {
          desktop: '10px 0 50px 0',
          mobile: '25px 0 30px 0',
        },
        fontSize: '16px',
      },
    },
  },
  postalCodeOverlay: {
    inputField: {
      padding: '18px 20px 19px 20px',
      height: '47px',
    },
  },
  photoUpload: {
    preamble: {
      color: '#555555',
      fontSize: '17px',
      fontWeight: 300,
      lineHeight: '24px',
    },
    button: {
      color: '#000',
      backgroundColor: 'transparent',
      border: '1px solid #000',
      fontSize: '13px',
    },
    buttonHover: {
      color: '#fff',
      backgroundColor: '#4d4d4d',
      border: '1px solid #4d4d4d ',
    },
    section: {
      padding: `0 0 20px 0`,
      borderBottom: `none`,
    },
    container: {
      padding: `20px 0`,
      marginLeft: '0',
    },
    checkbox: {
      text: {
        fontSize: '13px',
        fontWeight: 400,
      },
    },
  },
  contactDetails: {
    dt: {
      fontSize: '12px',
    },
  },
  bookingDetails: {
    storeName: {
      display: 'none',
    },
  },
  bookingSummary: {
    storeName: {
      display: 'none',
    },
  },
  confirmation: {
    header: {
      marginBottomDesktop: '18px',
      textTransform: 'none',
      fontSize: '30px',
      fontSizeDesktop: '48px',
    },
  },
  noTimeSuitable: {
    after: "content: ''",
  },
  quickQuestions: {
    container: {
      bottomBorder: 0,
      mobile: {
        padding: '0 20px',
        margin: '0 0 20px 0',
      },
      desktop: {
        padding: '10px 0',
        margin: '10px 0',
        flexDirection: 'column',
      },
    },
    heading: {
      style1: {
        color: theme('colors.link'),
        fontFamily: theme('typography.paragraph.fontFamily'),
        fontSize: {
          mobile: '16px',
          desktop: '16px',
        },
        fontWeight: 700,
        letterSpacing: '1px',
        lineHeight: {
          mobile: '22px',
          desktop: '22px',
        },
        margin: {
          mobile: '20px 0 10px 0',
          desktop: '20px 0 10px 0',
        },
        padding: 0,
        textTransform: 'none',
        width: '100%',
        minWidth: {
          desktop: '100%',
        },
      },
      style2: {
        color: theme('colors.link'),
        fontFamily: theme('typography.paragraph.fontFamily'),
        fontSize: {
          mobile: '22px',
          desktop: '32px',
        },
        fontWeight: 300,
        letterSpacing: 0,
        lineHeight: {
          mobile: '30px',
          desktop: '45px',
        },
        margin: {
          mobile: '20px 0 0 0',
          desktop: '20px 0 0 0',
        },
        padding: 0,
        textTransform: 'uppercase',
        width: '100%',
        minWidth: {
          desktop: '100%',
        },
      },
      style3: {
        color: theme('colors.link'),
        fontFamily: theme('typography.paragraph.fontFamily'),
        fontSize: {
          mobile: '22px',
          desktop: '32px',
        },
        fontWeight: 300,
        letterSpacing: 0,
        lineHeight: {
          mobile: '30px',
          desktop: '45px',
        },
        margin: {
          mobile: '20px 0 0 0',
          desktop: '20px 0 0 0',
        },
        padding: 0,
        textTransform: 'uppercase',
        width: '100%',
        minWidth: {
          desktop: '100%',
        },
      },
    },
  },

  questionBlock: {
    options: {
      margin: {
        mobile: '20px 0',
        desktop: '12px auto 0 0',
      },
    },
    anotherOption: {
      fontWeight: 400,
    },
    optionsItem: {
      width: {
        mobile: '400px',
        desktop: '400px',
      },
      margin: {
        mobile: '0 10px 10px 0',
        desktop: '0 10px 10px 0',
      },
    },
  },
  imageOption: {
    wrap: {
      flexDirection: 'column',
      padding: '10px',
    },
    image: {
      mobile: {
        width: '400px',
        maxWidth: '100%',
      },
      desktop: {
        width: '100%',
        height: '260px',
      },
    },
    text: {
      fontSize: {
        desktop: '16px',
      },
      marginTop: '16px',
      marginBottom: '16px',
    },
  },
  textOption: {
    wrap: {
      mobile: {
        padding: '0px 21px',
        width: 'auto',
      },
      desktop: {
        padding: '0px 21px',
      },
    },
    text: {
      fontFamily: theme('typography.paragraph.fontFamily'),
      fontSize: {
        mobile: '13px',
        desktop: '14px',
      },
      fontWeight: 700,
      active: {
        fontWeight: 700,
      },
      textAlign: 'left',
    },
  },
  buttonHover: `
    color: #333!important;
    border-color: #333;
    background: transparent!important;

  `,
  buttonHoverBefore: `
    background: transparent!important;
    transform: none!important;
  `,
  meetingTypeSelection: {
    meetingTypeItem: {
      flexDirection: 'row',
      textAlign: 'center',
      padding: '0 20px 10px 20px',
      display: 'flex',
    },
    margin: '0 0 80px 0',
  },
  meetingType: {
    name: {
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '18px',
      maxWidth: '100%',
    },
    text: {
      fontSize: '14px',
      fontWeight: 300,
      lineHeight: '18px',
      padding: '0 10px',
    },
    home: {
      marginTop: '10px',
      position: 'relative',
      top: '0',
    },
    video: {
      marginTop: 0,
      position: 'relative',
      top: '0',
    },
    store: {
      marginTop: '10px',
      position: 'relative',
      top: '0',
    },
  },
  GlobalStyles,
}
